import React from 'react';
import './FAQ.css';

const FAQ = () => {
  const faqs = [
    { 
      q: 'What kind of events do you provide decorations for?', 
      a: 'We provide professional decoration services for birthdays, anniversaries, baby showers, weddings, corporate events, and all special celebrations.' 
    },
    { 
      q: 'How do we book a service with you?', 
      a: 'You can book our services by calling us at 9992577729 or by contacting us through WhatsApp. Our team will guide you through the booking process.' 
    },
    { 
      q: 'How much does simple birthday decoration cost?', 
      a: 'Our birthday decorations start from ₹1,499. The final cost depends on the theme, size, and specific requirements. Contact us for a customized quote.' 
    },
    { 
      q: 'In which cities is Rahar Decors available?', 
      a: 'We provide services across major cities in India including Mumbai, Delhi, Bangalore, Ahmedabad, Pune, Chennai, Hyderabad, and many more.' 
    },
    { 
      q: 'How to contact you?', 
      a: 'You can reach us at 9992577729 via call or WhatsApp. We are available 24/7 to assist you with your decoration needs.' 
    }
  ];

  return (
    <section className="faq-section">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, idx) => (
            <div key={idx} className="faq-item">
              <div className="faq-question">
                <h4>{faq.q}</h4>
                <span className="faq-icon">+</span>
              </div>
              <div className="faq-answer">
                <p>{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
